(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-cargo-streams"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('.es-stream__play');
  if (!button) return;
  const holder = button.closest('.es-stream__embed');
  const videoId = holder && holder.dataset.videoId;
  if (!videoId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1';
  iframe.title = button.getAttribute('aria-label') || 'Electronic Subculture recording';
  iframe.loading = 'eager';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.setAttribute('allowfullscreen', '');
  holder.replaceChildren(iframe);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-soundcloud-listen"] && !Shopify.designMode) return;
  try {
    
(function(){
  // The theme may include this script even when the SoundCloud player is hidden.
  // In that case, do not register any listeners or create global state.
  if(!document.querySelector('.es-listen'))return;
  if(window.__esListenDragReady)return;
  window.__esListenDragReady=true;
  let active=null;
  document.addEventListener('pointerdown',function(e){
    const handle=e.target.closest('.es-listen__drag');
    if(!handle || e.button!==0 || window.matchMedia('(max-width: 749px)').matches)return;
    const player=handle.closest('.es-listen');if(!player)return;
    e.preventDefault();e.stopPropagation();
    const rect=player.getBoundingClientRect();
    active={handle,player,dx:e.clientX-rect.left,dy:e.clientY-rect.top};
    player.style.left=rect.left+'px';player.style.top=rect.top+'px';player.style.right='auto';player.style.bottom='auto';
    handle.setPointerCapture(e.pointerId);
  },true);
  document.addEventListener('pointermove',function(e){
    if(!active)return;
    e.preventDefault();
    const w=active.player.offsetWidth,h=active.player.offsetHeight;
    const x=Math.max(0,Math.min(window.innerWidth-w,e.clientX-active.dx));
    const y=Math.max(0,Math.min(window.innerHeight-h,e.clientY-active.dy));
    active.player.style.left=x+'px';active.player.style.top=y+'px';
  });
  document.addEventListener('pointerup',function(){active=null;});
  document.addEventListener('pointercancel',function(){active=null;});
  document.addEventListener('click',function(e){if(e.target.closest('.es-listen__drag')){e.preventDefault();e.stopPropagation();}},true);
  document.addEventListener('keydown',function(e){
    const handle=e.target.closest('.es-listen__drag');
    if(!handle || window.matchMedia('(max-width: 749px)').matches)return;
    if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))return;
    e.preventDefault();const p=handle.closest('.es-listen');const r=p.getBoundingClientRect(),step=e.shiftKey?40:12;
    const x=Math.max(0,Math.min(window.innerWidth-r.width,r.left+(e.key==='ArrowRight'?step:e.key==='ArrowLeft'?-step:0)));
    const y=Math.max(0,Math.min(window.innerHeight-r.height,r.top+(e.key==='ArrowDown'?step:e.key==='ArrowUp'?-step:0)));
    p.style.left=x+'px';p.style.top=y+'px';p.style.right='auto';p.style.bottom='auto';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
